/**
 * Implements modulus adjustment equation from http://www.eng.auburn.edu/users/timmdav/PerRoad_ACTempAdjustment.html
 * @param pgGradeUpper
 * @param airTemp_degF
 * @param thickness_in
 * @param maxE
 * @param minE
 */
export const temperatureAdjustedStiffnessPsi = function (pgGradeUpper: number,
                                                         airTemp_degF: number,
                                                         thickness_in: number,
                                                         maxE: number = 4000000,
                                                         minE: number = 50000): number | null {
  // Calculate pavement temp
  
  // representative depth
  const z = thickness_in / 3;
  const pvmtTemp_degF = airTemp_degF * (1 + 1 / (z + 4)) - (34 / (z + 4)) + 6;

  // Get k values
  let k1 = 0;
  let k2 = 0;

  if (pgGradeUpper > 70) {
    k1 = 8187876;
    k2 = -0.034;
  } else if (pgGradeUpper >= 64) {
    k1 = 7351157;
    k2 = -0.038;
  } else if (pgGradeUpper >= 58) {
    k1 = 5677719;
    k2 = -0.045;
  } else if (pgGradeUpper < 58) { // Originally <= 52, but leaves a discontinuity in the response
    k1 = 4841000;
    k2 = -0.048;
  }

  // Apply the stiffnes equation
  let eHma_psi = k1 * Math.exp(k2 * pvmtTemp_degF);

  if (eHma_psi > maxE) {
    eHma_psi = maxE;
  } else if (eHma_psi < minE) {
    eHma_psi = minE;
  }

  return eHma_psi;
};
